import React from "react";

const TableHeaderContext = React.createContext();

export default TableHeaderContext;
